import React, { useState } from "react";
import { motion } from "framer-motion";
import HousingPlot from "../../layout/realestateagent/HousingPost/HousingPlot";
import PropertyPost from "../../layout/realestateagent/HousingPost/PropertyPost";
import Transaction from "./Transaction"; // We'll need to modify Transaction to be used as content
import Layout from "../../layout/realestateagent/Layout";

const RealEstateLayout = () => {
    const [activeTab, setActiveTab] = useState("houseSale");

    const tabs = [
        { id: "houseSale", label: "House Sale" },
        { id: "houseRental", label: "House Rental" },
        { id: "housingPlotsSale", label: "Housing Plots Sale" },
        { id: "landSale", label: "Land Sale" },
        { id: "payment", label: "Payment" },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "houseSale":
                return <HousingPlot key="houseSale" listingMode="Sale" />;
            case "houseRental":
                return <HousingPlot key="houseRental" listingMode="Rent" />;
            case "housingPlotsSale":
                return <PropertyPost key="housingPlotsSale" plotMode="Plots" />;
            case "landSale":
                return <PropertyPost key="landSale" plotMode="Land" />;
            case "payment":
                // For now, we'll try to use Transaction, but it might need extraction
                // If Transaction has its own Layout, we might need a sub-component
                return <Transaction isContentOnly={true} />;
            default:
                return <HousingPlot listingMode="Sale" />;
        }
    };

    return (
        <Layout>
            <div className="min-h-screen bg-white px-1 xs:px-2 sm:px-3 py-4">
                <div className="w-full max-w-6xl mx-auto">
                    {/* Main Tab Navigation */}
                    <div className="mb-6 overflow-x-auto no-scrollbar py-2">
                        <div className="inline-flex items-center p-1.5 rounded-[40px] bg-white border border-gray-100 shadow-sm min-w-max">
                            {tabs.map((tab) => {
                                const isActive = activeTab === tab.id;
                                return (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`
                                            relative z-10 
                                            flex items-center justify-center 
                                            px-6 py-2.5 
                                            text-sm font-semibold 
                                            rounded-[32px] 
                                            transition-colors duration-200
                                            outline-none
                                            ${isActive ? "text-white" : "text-gray-500 hover:text-gray-900"}
                                        `}
                                    >
                                        {isActive && (
                                            <motion.div
                                                layoutId="activeTabAgent"
                                                className="absolute inset-0 bg-[#007AFF] shadow-sm rounded-[32px] -z-10"
                                                transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                                            />
                                        )}
                                        <span className="relative z-10">{tab.label}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div>{renderContent()}</div>
                </div>
            </div>
        </Layout>
    );
};

export default RealEstateLayout;
